import { LayoutEditControl } from '../appbuilder/common/layouteditcontrol/layout.edit.control';
import { AccordionMenuControl } from '../appbuilder/common/menutabcontrol/accordion.menu.control';
import { MenuTabControl } from '../appbuilder/common/menutabcontrol/menu.tab.control';
import { LayoutUnitThicknessComponent } from '../appbuilder/controls/layoutunitthickness/layoutunitthickness.component';
import { UnitSelectionControl } from '../appbuilder/controls/unittypeselection/unitselection.theme.control';
import { BaseAction } from '../components/actions/base.action';
import { BaseTreeControl } from '../components/common/basetreecontrol/base.tree.control';
import { CapsuleTagControl } from '../components/common/capsuletagcontrol/capsule.tag.control';
import { UserOverviewControl } from '../components/common/collaboration/user.overview.control';
import { ComponentFilterControl } from '../components/common/componentfilter/componentfilter.control';
import { ContextMenuComponent } from '../components/common/contextmenu/contextmenu.component';
import { DataSourceSelectionControl } from '../components/common/datasourceselectioncontol/datasource.selection.control';
import { BranchSelectControl } from '../components/common/development/branchselect/branchselect.control';
import { RepositorySelectControl } from '../components/common/development/repositoryselect/repositoryselect.control';
import { DropDownControl } from '../components/common/dropdowncontrol/dropdown.control';
import { CommonEditorControl } from '../components/common/editorcontrol/common.editor.control';
import { FormulaEditor } from '../components/common/formulaEditor/formulaEditor.control';
import { IndeterminateCheckbox } from '../components/common/indeterminatecheckbox/indeterminate.checkbox';
import { JiraControl } from '../components/common/jiracontrol/jira.control';
import { NavigationControl } from '../components/common/navigationcontrol/navigation.control';
import { NavigationTabsControl } from '../components/common/navigationcontrol/navigation.tabs';
import { ComparsionOverlay } from '../components/common/overlays/comparison/comparison.overlay';
import { ProgressBarWizard } from '../components/common/progressbarwizard/progressbar.wizard';
import { PropertyControl } from '../components/common/propertyControl/property.control';
import { RequestOptionsControl } from '../components/common/requestoptions/request.options.control';
import { ScriptEditor } from '../components/common/scripteditor/scripteditor.control';
import { SendMailSettingsControl } from '../components/common/sendmailsettings/send.mail.settings.control';
import { TimeSpanControl } from '../components/common/timespanControl/timespan.control';
import { WorkerInfoControl } from '../components/worker/worker.info.control';
import { ThirdPartyNoticesControl } from '../components/common/thirdpartynotices/thirdparty.notices.control';
import { LogsdialogComponent } from '../settings/logsettings/logsdialog.component';
import { DefaultDefinitionControl } from '../workflow/modules/containeroperations/default.definition.control';

export const APP_COMMON = [
    PropertyControl,
    FormulaEditor,
    ComponentFilterControl,
    TimeSpanControl,
    BaseAction,
    ContextMenuComponent,
    BaseTreeControl,
    DropDownControl,
    NavigationTabsControl,
    NavigationControl,
    IndeterminateCheckbox,
    RequestOptionsControl,
    MenuTabControl,
    AccordionMenuControl,
    CapsuleTagControl,
    LayoutEditControl,
    DataSourceSelectionControl,
    ScriptEditor,
    LayoutUnitThicknessComponent,
    UnitSelectionControl,
    UserOverviewControl,
    LogsdialogComponent,
    BranchSelectControl,
    RepositorySelectControl,
    ComparsionOverlay,
    JiraControl,
    ProgressBarWizard,
    WorkerInfoControl,
    ThirdPartyNoticesControl,
    DefaultDefinitionControl,
    SendMailSettingsControl,
    CommonEditorControl
];
